var map = {
	"./about-card.de-CH.json": 1414,
	"./about-card.de-DE.json": 1415,
	"./about-card.en-CA.json": 1416,
	"./about-card.en-GB.json": 1417,
	"./about-card.en-IN.json": 1418,
	"./about-card.en-ME.json": 1419,
	"./about-card.en-US.json": 1420,
	"./about-card.es-EM.json": 1421,
	"./about-card.es-ES.json": 1422,
	"./about-card.fr-BE.json": 1423,
	"./about-card.fr-CA.json": 1424,
	"./about-card.fr-CH.json": 1425,
	"./about-card.nl-BE.json": 1426,
	"./about-card.nl-NL.json": 1427,
	"./about-card.pl-PL.json": 1428,
	"./about-card.pt-BR.json": 1429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1413;